import { useTranslation } from 'react-i18next';
import { Recommendations } from './widgets';
import { PageContainer } from '@widgets';

export const ConciergePage = () => {
  const { t } = useTranslation('concierge');

  return (
    <PageContainer title={t('title')} header={t('header')}>
      <Recommendations />
    </PageContainer>
  );
};
